import type { GyymRequest, InferGyymRequestParams } from '@gyym/sdk'

import type { PrefetchConfig } from './types'

export const gyymPrefetch = async <T extends GyymRequest>(
  request: T,
  ...params: InferGyymRequestParams<T>
) => {
  const key = request.getKey(...params)

  console.log('[Fetch]', key)

  return [key, await request(...params)] as PrefetchConfig<T>
}
